import request from '@/utils/request';

/**
 * 英语教师老师端-我的课程
 */
export async function getSubjectLessonPage(params: any) {
  return request('/crm-teaching/lesson/getSubjectLessonPage', {
    method: 'POST',
    data: params,
  });
}

/**
 * 获取约课备注
 */
export async function getBookingRemark(params: any) {
  return request('/crm-market/subjectLeads/getBookingRemark', {
    method: 'GET',
    params: params,
  });
}

/**
 * 英语教师老师端-课后反馈详情
 */
export async function getSubjectLessonFeedBack(params: any) {
  return request('/crm-teaching/lesson/getSubjectLessonFeedBack', {
    method: 'GET',
    params: params,
  });
}

/**
 * 英语教师老师端-提交课后反馈
 */
export async function submitSubjectLessonFeedBack(params: any) {
  return request('/crm-teaching/lesson/submitSubjectLessonFeedBack', {
    method: 'POST',
    data: params,
  });
}

/**
 * 获取英语备注记录接口
 */
export async function getFollowRecordPage(params: any) {
  return request('/crm-market/subjectLeadsRemark/getFollowRecordPage', {
    method: 'GET',
    data: params,
  });
}